<template>
<div id="allmembers">
     <v-dialog
      v-model="loading_"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{'general._wait_'|translate}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4> Employee {{$t('dashboard._Valid_members_')}}: {{this.users_ecc.length}}</h4></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        right
        append-icon="search"
        label="Recherche"
        single-linef
        hide-details
      ></v-text-field>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
   
     <div class="btn-group center">
  <v-btn color="success" @click="refresh()"  ><v-icon>refresh</v-icon></v-btn> 
  
</div>
   <b>{{waiting}} </b>

       <template style="text-align:center;"  >
       <h2 v-show="this.users_ecc_emp_crea.length >0">  Users list ({{this.users_ecc_emp_crea.length}}) : </h2>
        <v-data-table align="center"
         v-show="this.users_ecc_emp_crea.length >0"
          :headers="headers_2"
          :items="users_ecc_emp_crea"
          class="elevation-0"
          :pagination.sync="pagination"
          :search="search"
          item-key="id">
       
          <template slot="items" slot-scope="props">
            
            <tr class="text-xs-left"  style="cursor: pointer">
            <td class="text-xs-left">
            <div class="images" v-viewer>
           <v-avatar size="36px">
            <img :src="props.item.image_url" />
             </v-avatar>
            </div>   
            </td>
            <td class="text-xs-left">{{ props.item.first_name }}</td> 
            <td class="text-xs-left">{{ props.item.last_name }}</td>
            <td class="text-xs-left">{{ props.item.phone }}</td>  
            </tr>
          </template>
        </v-data-table>
      </template>

  <h4> click on the employee to get the list of the users </h4>
    <v-card-text class="pa-0">
      <template>
         <h2 v-show="this.users_ecc_emp_crea.length >0">  Employees list : </h2>
        <v-data-table
          :headers="headers"
          :items="users_ecc"
          class="elevation-0"
          :pagination.sync="pagination"
          :search="search"
          item-key="id">
       
          <template slot="items" slot-scope="props">
            <tr class="text-xs-left"  style="cursor: pointer" @click="getUsers(props.item.uuid)">
            <td class="text-xs-left">
            <div class="images" v-viewer>
           <v-avatar size="36px">
            <img :src="props.item.image_url" />
             </v-avatar>
            </div>   
            </td> 
           
            <td class="text-xs-left">{{ props.item.card_id }}</td>
            <td class="text-xs-left">{{ props.item.first_name }}</td>
            <td class="text-xs-left">{{ props.item.last_name }}</td>
            <td class="text-xs-left">{{ props.item.phone }}</td>
            <td class="text-xs-left">{{ props.item.role }}</td>
            <td class="text-xs-left">{{ props.item.church_name }}</td>   
            </tr>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</div>
</template>

<script>
/* eslint-disable */ 
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
import { storage } from '@/api/firebaseInit';
import _ from "lodash";
export default {
  data () {
    return {
      waiting:'',
      specific_select:[],
       selected: [],
      selectAll: false,
      search: '',
      loading_: false,
      good_togo:false,
           headers_2: [
         
          {
            text:'image_url',
            align: 'left',
            sortable: false,
            value: 'image_url',
            width: "10%"
          },
          { text:'first_name', value: 'first_name',width: "1%" },
          { text:'last_name', value: 'last_name',width: "1%" },
          { text:this.$t('members._phone_'), value: 'phone' },
        ],
        headers: [
         
          {
            text:'image_url',
            align: 'left',
            sortable: false,
            value: 'image_url',
            width: "10%"
          },
      

          { text:'card_id' , value: 'card_id', width: "20%" },
        
          { text:'first_name', value: 'first_name',width: "1%" },
          { text:'last_name', value: 'last_name',width: "1%" },
         
          { text:this.$t('members._phone_'), value: 'phone' },
           { text:'role' , value: 'role' },
          { text:this.$t('members._churchName_') , value: 'church_name',width: "1%" },
       
        
        ],
 // Card_ID  First_name  Last_name  Sex  Date_of_birth  
 //Role  Member_since_date  Qr_name  Standard_photo_name
       //'Qr Code': 'qr_url',
          //'Image': 'standard_photo',
        json_fields: {
          'Card_ID':'card_id',
          'First_name': 'first_name',
          'Last_name': 'last_name',
          'Sex': 'gender',
          'Date_of_birth':'date_of_birth',
          'Role': 'role',  
          'Member_since_date': 'member_since',
          'Qr_name':'qr_name',
          'Standard_photo_name':'image_name',
          'Church_name':'church_name',
          'Payment_made':'payment_made',
          'Amount':'amount',
          'Bar_code':'bar_code'
      },
      
        pagination: {
          sortBy: 'lastName',
          rowsPerPage: '100'
        },
    };
  },
   computed: {
    users_ecc () {
      let users_ecc = this.$store.getters.users_ecc_emp;
      return users_ecc;
    },
     users_ecc_emp_crea () {
      let users_ecc_emp_crea = this.$store.getters.users_ecc_emp_crea;
      return users_ecc_emp_crea;
    },
  },
  watch: {
    users_ecc_emp_crea () {
      let users_ecc_emp_crea = this.$store.getters.users_ecc_emp_crea;
      return users_ecc_emp_crea;
    },
    users_ecc(val) {
     let users_ecc = this.$store.getters.users_ecc_emp;
      return users_ecc
    },

  },
  methods: {

           sleep(ms) {

        return new Promise(resolve => setTimeout(resolve, ms));
      },
 dataLoading () {
       let loading = true
       if (this.users_ecc.length !=0) {
         loading = false
          
       }
    
      return loading;
    },
   async  refresh () {
      this.waiting = "";
      this.waiting = "please wait ...";
     // this.loading_ = true;
      console.log(this.waiting)
      this.$store.dispatch('fetchUsers_ecc');
     
      if (this.users_ecc.length!=0){
         await this.sleep(1000);
        this.loading_=false;
        this.waiting= ''
         }
     
    },

    // for future use;
    async getUsers(id) {
      //alert(id)
      this.users_ecc_emp_crea = []
      this.$store.dispatch('fetchCRE_ecc_emp',id);
       await this.sleep(1000);
     // console.log(users_ecc_emp_crea)
      window.scrollTo(0, 0);
      },


  },
}
</script>

<style>
td {
  width: 150px !important;
}
.image {
  height: 20px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}

.right_side_div {
 
    position: relative;
}

.right_side_div button {
    float: right;
    margin-left: -80%;
}
.btn-group button {
  background-color: #4CAF50; /* Green background */
  border: 1px solid green; /* Green border */
  color: white; /* White text */
  padding: 10px 24px; /* Some padding */
  cursor: pointer; /* Pointer/hand icon */
  float: left; /* Float the buttons side by side */
}

/* Clear floats (clearfix hack) */
.btn-group:after {
  content: "";
  clear: both;
  display: table;
}

.btn-group button:not(:last-child) {
  border-right: none; /* Prevent double borders */
}

/* Add a background color on hover */
.btn-group button:hover {
  background-color: #3e8e41;
}

.center {
  margin: auto;
  width: 60%;
  padding: 10px;
}
</style>




// WEBPACK FOOTER //
// src/pages/widgets/AllUsers_ecc_emp.vue